module.exports = {
  devTools: false,
  api: {
    baseUrl: 'https://back.terra-home.fr/api',
    // baseUrl: 'http://172.10.10.70:10899/api',
  },
  crypto_key: 'Jnnrc3CPM2wdwGuKw8vqn8',
}
